import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import { isNullOrEmpty } from '../../../../../utils/vuex';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import isObject from 'lodash/isObject';

var getDeviceParsedPackets = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(deviceId) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", NiotaClassicApiService.deviceFetchParsedPackets(deviceId, {
              limit: 1
            }).then(function (res) {
              return get(res, 'data.data');
            }).then(function (lastValues) {
              if (!lastValues) {
                return lastValues;
              }

              var result;
              Object.keys(lastValues).forEach(function (key) {
                if (!result) {
                  result = {};
                }

                result[key] = get(lastValues, "".concat(key, "[0]"));
              });
              return result;
            }).catch(function () {
              return null;
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getDeviceParsedPackets(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getDevicePackets = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(deviceId) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", NiotaClassicApiService.deviceFetchPackets(deviceId, 0, 1).then(function (res) {
              return get(res, 'data.packets[0]', {});
            }).then(function (packet) {
              if (!packet) {
                return packet;
              }

              var result = {};

              if (packet.source === 'raw') {
                result['value'] = {
                  time: packet.source_time,
                  variable: 'value',
                  value: isObject(packet.parsed) ? JSON.stringify(packet.parsed) : packet.parsed
                };
              } else {
                var parsedPacket = get(packet, 'source_data.parsed_packet', {});
                Object.keys(parsedPacket).forEach(function (key) {
                  result[key] = {
                    time: packet.source_time,
                    variable: key,
                    value: isObject(parsedPacket[key]) ? JSON.stringify(parsedPacket[key]) : parsedPacket[key]
                  };
                });
              }

              return result;
            }).catch(function () {
              return null;
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getDevicePackets(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var getDeviceVariables = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(deviceId, deviceTypeId) {
    var parser, parsedPackets;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return NiotaClassicApiService.deviceTypeGetDetails(deviceTypeId).then(function (res) {
              var parser = get(res, 'data.devicetype.parser.config.variables') || {};

              if (get(res, 'data.devicetype.parser.type') === 'multi') {
                parser = {};
                var parserKeys = Object.keys(get(res, 'data.devicetype.parser.config') || {}).filter(function (k) {
                  return k !== '__switch';
                });
                parserKeys.forEach(function (pKey) {
                  if (isObject(get(res, "data.devicetype.parser.config.".concat(pKey, ".variables")))) {
                    parser = _objectSpread(_objectSpread({}, parser), get(res, "data.devicetype.parser.config.".concat(pKey, ".variables")) || {});
                  }
                });
              }
              /* 
              ORIGIN: {
                "temperature": {
                  "name": "temperature",
                  "value_type": { // << MUST BE FILLED!
                    "name": "°C"
                  }
                }
              }
              TARGET: {
                "temperature": {
                  "time": "2019-05-28T14:17:36.000Z",
                  "value": 29.75,
                  "value_type_name": "°C",
                  "variable": "temperature"
                }
              } */


              Object.keys(parser).forEach(function (parserKey) {
                if (!parser[parserKey]['value_type']) {
                  delete parser[parserKey];
                } else {
                  parser[parserKey].variable = parserKey;
                  parser[parserKey].value_type_name = // prefer to use the base-unit, as the value will be converted to that
                  get(parser, "".concat(parserKey, ".value_type.base_unit")) || get(parser, "".concat(parserKey, ".value_type.name"));
                  parser[parserKey].value = 'N/A';
                }
              });
              return parser;
            }).catch(function () {
              return null;
            });

          case 2:
            parser = _context3.sent;

            if (!parser) {
              parser = {};
            }

            _context3.next = 6;
            return getDeviceParsedPackets.call(this, deviceId).catch(function () {
              return null;
            });

          case 6:
            parsedPackets = _context3.sent;

            if (parsedPackets) {
              _context3.next = 11;
              break;
            }

            _context3.next = 10;
            return getDevicePackets.call(this, deviceId).catch(function () {
              return null;
            });

          case 10:
            parsedPackets = _context3.sent;

          case 11:
            if (parser) {
              Object.keys(parser).forEach(function (variableKey) {
                if (parsedPackets[variableKey]) {
                  parser[variableKey].value = parsedPackets[variableKey].value;
                  parser[variableKey].time = parsedPackets[variableKey].time;
                }
              });
            }

            return _context3.abrupt("return", parser);

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getDeviceVariables(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

export default {
  name: 'CoreDtwinStateIothubEdit',
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    tenantId: {
      type: Number,
      required: true
    },
    // is this an 'edit', 'create', or mass-variable- 'import'?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      // the current result-set for the autocomplete device search
      niotaDevices: [],
      loadingDevices: false,
      niotaDeviceSearch: '',
      selectedNiotaDevice: null,
      niotaDeviceVariableHeaders: [{
        sortable: true,
        text: 'Name',
        value: 'variable',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
        value: 'value',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.lastUpdate'),
        value: 'milliseconds_ago',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.unit'),
        value: 'value_type_name',
        align: 'left'
      }],
      niotaDeviceVariableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [20, 50, {
          text: this.$i18n_t('Common.all'),
          value: -1
        }]
      },
      // the retrieved variables for the selected device
      niotaDeviceVariables: null,
      selectedNiotaDeviceVariable: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    hasManageAllPermissions: function hasManageAllPermissions() {
      return this.permissions['all.manage'];
    },
    formIsValid: function formIsValid() {
      return !isNullOrEmpty(this.selectedNiotaDevice) && !isNullOrEmpty(this.selectedNiotaDeviceVariable) && this.selectedNiotaDeviceVariable.length > 0;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    }
  }),
  watch: {
    niotaDeviceSearch: function niotaDeviceSearch(val) {
      if (!val || val.length < 2) {
        // if search value is empty or less than two characters do not start a search
        // but treat the old search as invalid as a new search is as about to happen
        // in this state no results will be shown in the auto-complete dropdown
        // because we set `niotaDevices` to an array with only `selectedNiotaDevice`
        // which will not show up because auto-completes `hide-selected` is true
        // while `loadingDevices` is true or the search is empty or less than two characters
        this.niotaDevices = [this.selectedNiotaDevice].filter(function (d) {
          return d;
        });
        return;
      } // do not trigger the device-search (again) after the item has been selected
      // that would clear the variable-set


      if (!this.selectedNiotaDevice || !this.selectedNiotaDevice.title || val !== this.selectedNiotaDevice.title) {
        // set loadingDevices to true as early as the debounced fetchDevices will be called
        // to not delay the loading state when settings it from the debounced method
        this.loadingDevices = true;
        this.fetchDevices();
      }
    },
    selectedNiotaDevice: function selectedNiotaDevice(val) {
      if (val !== null) {
        this.fetchVariables();
      }

      this.emitSelection();
    },
    selectedNiotaDeviceVariable: function selectedNiotaDeviceVariable() {
      this.emitSelection();
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.mode !== 'create' && this.mode !== 'import' && this.lclModel.properties.binding.options.identifier) {
      NiotaClassicApiService.deviceGetDetails(this.lclModel.properties.binding.options.identifier).then(function (res) {
        var device = get(res, 'data.device');

        if (!device || !device.id) {
          throw new Error('NIOTA_DEVICE_NOT_FOUND');
        }

        _this2.niotaDevices = device ? [device] : null;
        _this2.selectedNiotaDevice = device;
      }).catch(function (error) {
        console.error(get(error, 'response.status'));

        if (get(error, 'response.status') === 403) {
          // user has no permission to read the device
          // probably some other user linked it, and this user cannot read it
          // so emit the no-permission event here to trigger the edit-dialog to be closed
          _this2.$emit('no-permission', _this2.$i18n_t('DigitalTwin.DigitalTwin.states.noPermissionError'));

          return;
        }

        console.error(error);
        var errorMessage = get(error, 'response.data.message', error.message);
        var errorOutput = _this2.$i18n_te("Error.".concat(errorMessage)) ? _this2.$i18n_t("Error.".concat(errorMessage)) : _this2.$i18n_t(errorMessage);

        _this2.$snack(errorOutput, 'error');

        _this2.niotaDevices = null;
        _this2.selectedNiotaDevice = null;
      }).finally(function () {
        _this2.loading = false;
      });
      this.selectedNiotaDeviceVariable = [{
        variable: this.lclModel.properties.binding.options.variable
      }];
    }
  },
  methods: {
    emitSelection: function emitSelection() {
      this.$emit('bridge-binding-changed', {
        valueType: get(this.selectedNiotaDeviceVariable, '[0].value_type_name'),
        variable: get(this.selectedNiotaDeviceVariable, '[0].variable'),
        value: get(this.selectedNiotaDeviceVariable, '[0].value')
      });
    },
    fetchDevices: debounce(function () {
      var _this3 = this;

      this.loadingDevices = true;
      NiotaClassicApiService.devicesFind(this.niotaDeviceSearch, 0, 50, 'title', 'ASC').then(function (res) {
        // only allow devices with a devicetype, as otherwise there are no parsed variables to choose from
        _this3.niotaDevices = get(res, 'data.devices', []).filter(function (device) {
          return device.deviceTypeId;
        });
      }).catch(function (error) {
        console.error(error);
        var errorMessage = get(error, 'response.data.message', error.message);
        var errorOutput = _this3.$i18n_te("Error.".concat(errorMessage)) ? _this3.$i18n_t("Error.".concat(errorMessage)) : _this3.$i18n_t(errorMessage);

        _this3.$snack(errorOutput, 'error');

        _this3.niotaDevices = [];
      }).finally(function () {
        _this3.loadingDevices = false;
      });
    }, 250),
    fetchVariables: function fetchVariables() {
      var _this4 = this;

      this.niotaDeviceVariables = null;

      if (!get(this, 'selectedNiotaDevice.id') || !get(this, 'selectedNiotaDevice.deviceTypeId')) {
        return;
      }

      getDeviceVariables(this.selectedNiotaDevice.id, this.selectedNiotaDevice.deviceTypeId).then(function (variables) {
        var variableKeys = Object.keys(variables);
        _this4.niotaDeviceVariables = variableKeys.map(function (key) {
          var variable = variables[key];

          if (variable.time) {
            variable['milliseconds_ago'] = new Date() - new Date(variable.time);
            variable['time_ago'] = variable['milliseconds_ago'];
            var units = ['seconds', 'minutes', 'hours', 'days', 'months'];
            var conversion = [1000, 60, 60, 24, 30];
            var selectedUnit = 0;

            while (variable['time_ago'] >= conversion[selectedUnit] && selectedUnit < conversion.length) {
              variable['time_ago'] = Math.floor(variable['time_ago'] / conversion[selectedUnit]);
              selectedUnit++;
            }

            selectedUnit--;
            variable['time_ago'] = "".concat(variable['time_ago'], " ").concat(units[selectedUnit]);
          }

          return variable;
        });
      }).catch(function (error) {
        console.error(error);
        var errorMessage = get(error, 'response.data.message', error.message);
        var errorOutput = _this4.$i18n_te("Error.".concat(errorMessage)) ? _this4.$i18n_t("Error.".concat(errorMessage)) : _this4.$i18n_t(errorMessage);

        _this4.$snack(errorOutput, 'error');

        _this4.niotaDeviceVariables = [];
      });
    },
    saveState: function saveState() {
      this.lclModel.properties.binding.options.identifier = get(this.selectedNiotaDevice, 'id');
      this.lclModel.properties.binding.options.variable = get(this.selectedNiotaDeviceVariable, '[0].variable');
    }
  }
};